exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.hn-footer {\n  padding-bottom: 1rem;\n  background: #111;\n  color: #fff;\n  font-size: 0.875rem;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-814328f2","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppFooter.vue
// module id = NKmT
// module chunks = 14